'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.is-concat-spreadable.js
// module id = 818
// module chunks = 111